import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ROUTERS } from '../../constants/common.constants';

const Home = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(ROUTERS.REGISTER);
  }, []);
  return null;
};

export default Home;
